<div class="pd-shell">
  <div class="pd-shell__title-row">
    <div class="pd-shell__title-wrap">
      <span class="pd-shell__title">Prediction Drift</span>
    </div>
    <div class="pd-shell__subtitle">Select one or more polygons on the map or run prediction for all detections.</div>
  </div>

  <div class="pd-section-label">Prediction Mode</div>
  <div class="pd-mode-grid">
    <button type="button" class="pd-mode-card" [class.is-active]="mode === 'select'" (click)="onModeChange('select')">
      <div class="pd-mode-card__title">Select From Map</div>
      <div class="pd-mode-card__copy">Select up to 3 oil spill areas on the map.</div>
    </button>

    <button type="button" class="pd-mode-card" [class.is-active]="mode === 'all'" (click)="onModeChange('all')">
      <div class="pd-mode-card__title">Run For All Detections</div>
      <div class="pd-mode-card__copy">Run prediction for every detected oil spill area.</div>
    </button>
  </div>

  <div class="pd-hint" *ngIf="showEmptySelectHint">
    <mat-icon>info</mat-icon>
    <span>Select one or more detections on the map to see the estimated cost.</span>
  </div>

  <div class="pd-summary-card" *ngIf="mode === 'all' && !paymentCompleted">
    <div class="pd-summary-card__row">
      <span>Detected Polygons</span>
      <strong>{{ allDetectionsCount }}</strong>
    </div>
  </div>

  <div class="pd-list-card" *ngIf="showSelectionList">
    <div class="pd-list-card__header">
      <span>Selected Detections ({{ selectedCount }})</span>
      <button type="button" class="pd-clear-btn" (click)="clearAllDetections()">Clear All</button>
    </div>

    <div class="pd-list-row" *ngFor="let detection of selectedPolygons; let i = index">
      <span class="pd-list-row__swatch"></span>
      <span class="pd-list-row__name">{{ getDetectionLabel(i) }}</span>
      <span class="pd-list-row__area">Area: {{ getDetectionArea(detection) || 'N/A' }}</span>
      <button type="button" class="pd-list-row__remove" (click)="removeDetection(detection.id)">×</button>
    </div>
  </div>

  <div class="pd-summary-card pd-cost-card" *ngIf="showCostSection">
    <div class="pd-cost-card__header">
      <span>Cost Details</span>
    </div>

    <div class="pd-cost-loader pd-cost-loader--card" *ngIf="costLoading">
      <mat-icon>sync</mat-icon>
      <span>Updating latest price</span>
    </div>

    <ng-container *ngIf="!costLoading">
      <div class="pd-cost-item">
        <div class="pd-cost-item__icon pd-cost-item__icon--weather">
          <mat-icon>wb_cloudy</mat-icon>
        </div>
        <div class="pd-cost-item__content">
          <div class="pd-cost-item__title-row">
            <span class="pd-cost-item__title">{{ isPointCustomer ? 'Weather Data Points' : 'Weather Data Cost' }}</span>
            <span class="pd-cost-badge">Non-refundable</span>
          </div>
          <div class="pd-cost-item__description">{{ isPointCustomer ? 'Points for weather data required for prediction' : 'Cost for weather data required for prediction' }}</div>
        </div>
        <div class="pd-cost-amount">
          <span class="pd-cost-value pd-cost-value--points" *ngIf="isPointCustomer; else weatherCurrency">
            {{ formatPoints(weatherPoint) }}
          </span>
          <ng-template #weatherCurrency>
            <span class="pd-cost-value">{{ weatherCost | currencyFormat }}</span>
          </ng-template>
        </div>
      </div>

      <div class="pd-cost-divider"></div>

      <div class="pd-cost-item">
        <div class="pd-cost-item__icon pd-cost-item__icon--feed">
          <mat-icon>online_prediction</mat-icon>
        </div>
        <div class="pd-cost-item__content">
          <div class="pd-cost-item__title-row">
            <span class="pd-cost-item__title">{{ isPointCustomer ? 'Feed / Prediction Points' : 'Feed / Prediction Cost' }}</span>
          </div>
          <div class="pd-cost-item__feed-name" *ngIf="feedName">Feed: {{ feedName }}</div>
        </div>
        <div class="pd-cost-amount">
          <span class="pd-cost-value pd-cost-value--points" *ngIf="isPointCustomer; else feedCurrency">
            {{ formatPoints(feedPoint) }}
          </span>
          <ng-template #feedCurrency>
            <span class="pd-cost-value">{{ feedCost | currencyFormat }}</span>
          </ng-template>
        </div>
      </div>

      <div class="pd-cost-total-divider"></div>

      <div class="pd-cost-total">
        <span class="pd-cost-total__label">{{ isPointCustomer ? 'Total Points' : 'Total Cost' }}</span>
        <div class="pd-cost-total__amount">
          <span class="pd-cost-total__value pd-cost-total__value--points" *ngIf="isPointCustomer; else totalCurrency">
            {{ formatPoints(totalPoint) }}
          </span>
          <ng-template #totalCurrency>
            <span class="pd-cost-total__value">{{ cost | currencyFormat }}</span>
          </ng-template>
        </div>
      </div>

      <div class="pd-cost-notice">
        <mat-icon>info_outline</mat-icon>
        <span>{{ isPointCustomer ? 'Weather Data Points are non-refundable.' : 'Weather Data Cost is non-refundable.' }}</span>
      </div>
    </ng-container>

    <div class="pd-cost-error" *ngIf="costError">
      <span>{{ costErrorMessage }}</span>
      <button
        *ngIf="retryableCostError"
        type="button"
        class="pd-cost-error__retry"
        [disabled]="costLoading"
        (click)="retryCost()"
      >
        Please try again
      </button>
    </div>

    <button type="button" class="pd-pay-btn" [disabled]="paymentDisabled" (click)="proceedToPayment()">
      <mat-icon>{{ paymentRedirecting ? 'hourglass_top' : 'lock' }}</mat-icon>
      <span>{{ paymentRedirecting ? 'Redirecting to Payment...' : 'Proceed to Payment' }}</span>
    </button>
  </div>
</div>
